import React from 'react'
import './More.css';
import Carousel from 'react-bootstrap/Carousel'

const more = () => {
  return (
    <div className='body27'>
    <div className="row27">
      <div className="left27">
      <Carousel>
      <Carousel.Item>
        <img style={{height:'60vh'}}
        className='d-block w-100'
        src='./images/88.jpg'
        alt='first slide'
        
        />
        <Carousel.Caption>
          {/* <h3>First slide label</h3>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img style={{height:'60vh'}}
        className='d-block w-100'
        src='./images/89.jpg'
        alt='second slide'
        
        />
        <Carousel.Caption>
          {/* <h3>Second slide label</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img style={{height:'60vh'}}
        className='d-block w-100'
        src='./images/66.jpg'
        alt='third slide'
        
        />
        <Carousel.Caption>
          {/* <h3>Third slide label</h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
          </p> */}
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
      </div>
      <div className="right27">
        <div className="content27">
<p>Our woven fabric bags made of Polypropylene (PP) are more than just another option for packing; they are a combination of durability, versatility, and environmentally friendly design. These precisely crafted polypropylene bags make use of the properties of a robust thermoplastic polymer that is both adaptable and long-lasting. PP woven fabric bags, in contrast to conventional packaging materials, are made by weaving fine polypropylene threads, creating a sturdy structure that can withstand significant weight and abrasion.</p>
<p>Each bag is guaranteed to be resistant to moisture and chemical exposures thanks to this special weaving technique, giving it a trustworthy varying situations. However, our dedication doesn’t end with strength on its own. We provide a wide range of customization choices since we understand the many needs that modern organisations have. Our bags may be customised to meet your exact needs, whether that means adding a special lamination for extra protection or a particular pattern that will complement your brand.</p>
{/* <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Expedita consequuntur provident ducimus alias odio at commodi voluptatibus doloribus, quibusdam autem.</p> */}

        </div>
      </div>
    </div>
  </div>
  )
}

export default more
